import { useEffect, useState } from "react";
import apiClientTimeseries from "../../../services/apiClientTimeseries";
import { getHeaders as getMetricHeaders } from "../../ApiHeaders/apiHeadersTimeseries";

let cachedMetrics: any[] | null = null;

export const useMetricConfig = () => {
  const [data, setData] = useState<any[]>(cachedMetrics || []);
  const [loading, setLoading] = useState(!cachedMetrics);

  useEffect(() => {
    if (cachedMetrics) return;

    const fetchData = async () => {
      try {
        const headers = await getMetricHeaders();

        const res = await apiClientTimeseries.get("/metric-config/", {
          headers,
        });

        const metrics = res?.data?.response?.data || [];

        cachedMetrics = metrics; 

        setData(metrics);
      } catch (err) {
        console.error("Metric config failed", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return { data, loading };
};